import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'


import globalMU from "globalMU"

declare var window:any

export type DefinirFilialRetiradaParams = {
    identificadorItem: number,
    codigoFilialRetirada: string,
    atualizarEstadoLegadoImediatamente?: boolean
    itemLegado?:any
}

export async function definirFilialRetiradaItem(params: DefinirFilialRetiradaParams) {
    try {
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirFilialRetirada(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem,
            params.codigoFilialRetirada
        )

        const temErro = (orcamentoAtualizado["HasErrors"] != undefined) && orcamentoAtualizado["HasErrors"] == true // 466807
 
        const atualizarOrcamentoLegado = () => {
            const orcamentoLegado = window.orcamentoController.model
            if (!temErro) { // 466807
                
                const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)
        
                if (!params.atualizarEstadoLegadoImediatamente) {

                    store.dispatch(atualizacaoItensOrcamentoLegadoActions.atualizarItem({
                        identificador: itemAtualizado.Identificador,
                        dadosItem: itemAtualizado
                    }))
                } else {
                    //const itensLegado = orcamentoLegado.get('ItensOrcamento')
                    //const itemLegado = params?.itemLegado ?? itensLegado.models.find(item => item.get('Identificador') == params.identificadorItem)

                    //itemLegado.atualizar(itemAtualizado, true, true, true)
                }
            }
            
            orcamentoLegado.atualizar(
                orcamentoAtualizado, 
                params.atualizarEstadoLegadoImediatamente == true, 
                true)
                
            if (!params.atualizarEstadoLegadoImediatamente) {
                store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
            }
        }

        
        atualizarOrcamentoLegado()
        
    } catch (e) {
        
        throw e

    } finally {
        globalMU.unblockUI()
    }
}